import { render, staticRenderFns } from "./CreatorAttachments.vue?vue&type=template&id=2bbedcd2&"
import script from "./CreatorAttachments.vue?vue&type=script&lang=js&"
export * from "./CreatorAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports